import BootResultModal from "./boot-result-modal.component";

export default BootResultModal;
